const hasOtpErrors = (errors: DeserializeError) =>
  errors?.otp?.includes('OTP_IS_REQUIRED') ||
  errors?.otp?.includes('INVALID_USERNAME_PASSWORD_OR_OTP');

export default hasOtpErrors;
